export default "__VITE_ASSET__uCx$GeJG__"